/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  NenNascentToken,
  NenNascentTokenInterface,
} from "../NenNascentToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_baseTokenURI",
        type: "string",
      },
      {
        internalType: "address",
        name: "_fundOwner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "BalanceQueryForZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintERC2309QuantityExceedsLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "MintToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintZeroQuantity",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnerQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnershipNotInitializedForExtraData",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferFromIncorrectOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToNonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "URIQueryForNonexistentToken",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toTokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "ConsecutiveTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "AL_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_DEV_MINT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_SUPPLY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PUBLIC_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "maxMintableAmount",
        type: "uint256",
      },
    ],
    name: "alMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "alMintedByAddress",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseTokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "devMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "devMinted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fundOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "maxMintableAmount",
        type: "uint256",
      },
    ],
    name: "getCapabilitiesByWallet",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isAlMintActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isDevMintActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPublicMintActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "merkleRoot",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "maxMintableAmount",
        type: "uint256",
      },
    ],
    name: "ownerAlMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ownerPublicMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "publicMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newPrice",
        type: "uint256",
      },
    ],
    name: "setAlPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_baseTokenURI",
        type: "string",
      },
    ],
    name: "setBaseTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_fundOwner",
        type: "address",
      },
    ],
    name: "setFundOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newValue",
        type: "uint256",
      },
    ],
    name: "setMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_merkleRoot",
        type: "bytes32",
      },
    ],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newPrice",
        type: "uint256",
      },
    ],
    name: "setPublicPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "toggleIsAlMintActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "toggleIsDevMintActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "toggleIsPublicMintActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type NenNascentTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NenNascentTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NenNascentToken__factory extends ContractFactory {
  constructor(...args: NenNascentTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "NenNascentToken";
  }

  deploy(
    _baseTokenURI: string,
    _fundOwner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NenNascentToken> {
    return super.deploy(
      _baseTokenURI,
      _fundOwner,
      overrides || {}
    ) as Promise<NenNascentToken>;
  }
  getDeployTransaction(
    _baseTokenURI: string,
    _fundOwner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _baseTokenURI,
      _fundOwner,
      overrides || {}
    );
  }
  attach(address: string): NenNascentToken {
    return super.attach(address) as NenNascentToken;
  }
  connect(signer: Signer): NenNascentToken__factory {
    return super.connect(signer) as NenNascentToken__factory;
  }
  static readonly contractName: "NenNascentToken";
  public readonly contractName: "NenNascentToken";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NenNascentTokenInterface {
    return new utils.Interface(_abi) as NenNascentTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NenNascentToken {
    return new Contract(address, _abi, signerOrProvider) as NenNascentToken;
  }
}
